export const handleComparing = ({
  selectedDrawings,
  handleCloseCompareModal,
}) => {
  console.log(selectedDrawings);
  const sortedDrawings = selectedDrawings.sort(
    (a, b) => a.revision - b.revision
  );

  const comparedDrawing = {
    name: sortedDrawings[0]?.name || "",
    sheetNumber: sortedDrawings[0]?.sheetNumber || "",
    revs: [],
    comparedMaterials: [],
    v1: [],
    v2: [],
  };

  /// get Revisions
  sortedDrawings.forEach((drawing) => {
    if (drawing.name !== comparedDrawing.name) {
      handleCloseCompareModal();
      alert("Please select Revisions of the same Drawing ! ");
    }

    if (drawing.sheetNumber !== comparedDrawing.sheetNumber) {
      handleCloseCompareModal();
      alert("Please select Revisions of the same Sheet ! ");
    }

    comparedDrawing.revs.push(drawing.revision);
  });

  //// Compare Materials
  const d1 = sortedDrawings[0]?.materials.sort((a, b) => a.item - b.item) || [];
  const d2 = sortedDrawings[1]?.materials.sort((a, b) => a.item - b.item) || [];

  const requiredKeys = ["description", "quantity"];

  comparedDrawing.comparedMaterials = d1.map((item1) => {
    const item2 = d2.find((d) => d.softwareId === item1.softwareId);

    let mergedItem = {};

    if (!item2) {
      mergedItem = { ...item1, comparingState: "deleted" };
    } else {
      requiredKeys.forEach((key) => {
        if (item1[key] === item2[key]) {
          mergedItem = { ...item1, comparingState: "unchanged" };
        } else {
          mergedItem = {
            ...item1,
            comparingState: "changed",
            comparingKey: key,
            comparingValue1: item1[key],
            comparingValue2: item2[key],
            // add values
          };
        }
      });
    }

    return mergedItem;
  });

  comparedDrawing.v1 = d1.map((item1) => {
    const item2 = d2.find((d) => d.softwareId === item1.softwareId);

    let mergedItem = {};

    if (!item2) {
      mergedItem = { ...item1, comparingState: "deleted" };
    } else {
      requiredKeys.forEach((key) => {
        if (item2[key] === item1[key]) {
          mergedItem = { ...item1, comparingState: "unchanged" };
        } else {
          mergedItem = {
            ...item1,
            comparingState: "changed",

            // add values
          };
        }
      });
    }

    return mergedItem;
  });

  comparedDrawing.v2 = d2.map((item2) => {
    const item1 = d1.find((d) => d.softwareId === item2.softwareId);

    let mergedItem = {};

    if (!item1) {
      mergedItem = { ...item2, comparingState: "added" };
    } else {
      requiredKeys.forEach((key) => {
        if (item2[key] === item1[key]) {
          mergedItem = { ...item2, comparingState: "unchanged" };
        } else {
          mergedItem = {
            ...item2,
            comparingState: "changed",
            comparingKey: key,
            comparingValue1: item2[key],
            comparingValue2: item1[key],
            // add values
          };
        }
      });
    }

    return mergedItem;
  });

  return comparedDrawing;
};
